<template>
  <time
    id="running-time"
    class="running-time"
  >{{ elapsedTime.format('mm:ss') }}</time>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    since: {
      type: Object,
      required: true,
      default: null
    }
  },
  data () {
    return {
      intervalHandler: undefined,
      elapsedTime: moment()
    }
  },
  mounted () {
    if (this.since !== null) {
      this.intervalHandler = setInterval(this.updateTime, 1000)
      this.updateTime()
    }
  },
  beforeDestroy () {
    if (this.intervalHandler) {
      clearInterval(this.intervalHandler)
    }
  },
  methods: {
    updateTime () {
      this.elapsedTime = moment().utc().subtract(moment(this.since).format('X'), 's')
    }
  }
}
</script>
